<template>
   <transition name="modal">
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; top: 130px;">
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()"><span class="icon-close"></span></button>
        </div>
        <header class="modal-header">
          <h2 class="modal-title ">Search for existing investor, minor or advisor to add as new representative</h2>
        </header>
        <div class="modal-body mt-lg">
          <form role="form" class="mb-xl top-margin form-row" novalidate>
            <div class="form-group has-feedback searchbox">
              <input autofocus v-model="searchText" id="search" type="text"
              placeholder="Search by first name, last name, or user email" autocomplete="off" class="form-control">
              <button type="submit" class="btn btn-default btn-lg" :disabled="isSearchDisabled" @click.prevent="searchInvestors()"><em class="icon-magnifier pr-sm"></em> Search</button>
            </div>
          </form>
          <div v-if="investors.length === 0 && hasSearched" class="panel-body">
            <div class="alert alert-info alert-dismissible mt-lg not-found-alert" role="alert">
              <p><em class="icon-info pr-sm"></em>No results found.</p>
            </div>
          </div>
          <div v-if="representativeWasAdded" class="alert alert-success alert-dismissible" role="alert">
            <button @click="representativeWasAdded = false" type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <i class="fa fa-check-circle-o"></i> {{lastRepresentativeAdded}} was added successfully as representative.
          </div>
            <div v-if="investors.length > 0" class="table-responsive top-margin">
              <table class="table table-striped bank-accounts table-fundings">
                <thead>
                  <tr>
                    <th>First name</th>
                    <th>Last name</th>
                    <th>Email</th>
                    <th>User type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="investor in investors" :key="investor.id">
                    <td>{{investor.firstName}}</td>
                    <td>{{investor.lastName}}</td>
                    <td>{{investor.email}}</td>
                    <td>{{getUserTypeLabel(investor.userType)}}</td>
                    <td>
                      <button v-if="!isAccountRepresentative(investor.id)" type="button" class="btn btn-details btn-outline" @click="addRepresentativeToAccount(investor)">Add to account</button>
                      <span class="action-span green-text" v-else><i class="fa fa-check check"></i>Added</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
           <div class="modal-buttons mt-lg">
            <div class="row">
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-info btn-lg btn-done" @click="closeModal()">Done</button>
              </div>
            </div>
        </div>
        </div>
      </div>
  </transition>
</template>

<script>
 import {
    mapActions,
  } from 'vuex';

import { Events } from '@/data/static/events';
import _ from 'lodash';
import { getUserTypeLabel } from '@/util';
import { SearchTypes } from '@/data/static/searchTypes';


const mix = {
   methods: {
     getUserTypeLabel,
   },
};

export default {
   name: 'AddRepresentatives',
   data() {
     return {
       searchText: '',
       investors: [],
       lastRepresentativeAdded: '',
       representativeWasAdded: false,
       hasSearched: false,
       searchTypes: SearchTypes,
     };
   },
   mixins: [mix],
   props: {
     closeAction: {
       type: Function,
       required: true,
     },
     representatives: {
       type: Array,
       required: true,
       default: [],
     },
     accountId: {
       type: Number,
       required: true,
     },
   },
   computed: {
     isSearchDisabled() {
       return !this.searchText.length > 0;
     },
     authorizedRepresentatives() {
       return this.representatives;
     },
   },
   methods: {
     closeModal() {
       this.closeAction();
     },
     async searchInvestors() {
       try {
         if (!this.searchText.length) {
           this.investors = [];
           return;
         }
         const response = await this.getAccounts({
           searchString: this.searchText,
           searchBy: this.searchTypes.NAME_EMAIL.name,
         });
         this.hasSearched = true;
         if (response.statusCode === 401) {
           this.investors = [];
         } else {
           this.investors = response.users;
         }
       } catch (error) {
         this.setErrorsModalInfo(['We could not retrieve investors list']);
         this.showErrorsModal();
       }
     },
     ...mapActions('account', [
       'createAccountUser',
       'getAccounts',
     ]),
     async addRepresentativeToAccount(investor) {
       await this.createAccountUser({ accountId: this.accountId, userId: investor.id });
       this.$emit(Events.REPRESENTATIVE_ADDED);
       this.lastRepresentativeAdded = `${investor.firstName} ${investor.lastName}`;
       this.representativeWasAdded = true;
     },
     isAccountRepresentative(id) {
       return _.some(this.authorizedRepresentatives, ['id', id]);
     },
   },
};
</script>

<style scoped>
  .modal-wrapper {
    max-width: 760px;
  }

  .modal-title {
    font-size: 20px;
  }

  .searchbox {
    display: flex;
    flex-direction: row;
  }

  .searchbox input {
    height: 39px;
    flex: 1;
    border-radius: 4px 0 0 4px;
  }

  .searchbox .btn-default {
    text-align: center;
    border-radius: 0 4px 4px 0;
  }

  .modal-button {
    right: 0 !important;
  }

  .table-responsive {
    max-height: 265px;
    margin-bottom: 70px;
    overflow-y: scroll;
  }

  .green-text {
    color: #558c1d;
    font-weight: 800;
  }

  .action-span {
    display: block;
    height: 32px;
    min-width: 113px;
    padding: 5px 0;
  }

  .check {
    margin-right: 5px;
  }

  .btn-done {
    background-color: #27c24c;
    transition: all .4s ease-in-out;
    min-width: 93.05px;
    margin-right: 0;
  }

  .btn-done:hover {
    background-color: #1aa33b;
    border-color: transparent;
  }

  .alert-success {
    transition: all .4s ease-in-out;
  }

  .not-found-alert {
    margin-bottom: 50px;
  }

</style>



// WEBPACK FOOTER //
// AddRepresentatives.vue?98869406